import Footer from 'components/Footer/Index';
import { Redirect } from 'react-router-dom';
import { Button } from '@material-ui/core';


import { Container, Header, Wrapper } from './styles';
import { OauthHelper } from '../../helpers/OauthHelper';
import { useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { resetUser } from '../../config/store/slices/user.slice';
import { useAppSelector } from '../../config/store/hooks';
import { resetLocalUser } from '../../config/store/slices/local.user.slice';
import { ExternalURLsHelper } from '../../helpers/ExternalURLsHelper';
import { HmgLabelTopRight } from 'components/Navbar/styles';


const Home = () => {
  const dispatch = useDispatch();
  const userClaims = useAppSelector(state => state.user.claims);
  const isHmg = process.env.REACT_APP_DEPLOYED_ENVIRONMENT ? process.env.REACT_APP_DEPLOYED_ENVIRONMENT  === "HMG" : false;

  useEffect(() => {
    const token = sessionStorage.getItem('token');

    if (token && userClaims === null) {
      try {
        const user: any = jwtDecode(token);

        if ('idp_id' in user) {
          window.location.replace(`/callback#id_token=${token}`);
        }
      } catch (error) {
        console.warn('Invalid token');
      }
    }
  });

  if (userClaims != null) {
    return <Redirect push to='/private/mapper' />;
  }

  const handleLoginClick = () => {
    const url = OauthHelper.getAuthorizeUrl();
    dispatch(resetLocalUser({}));
    dispatch(resetUser());

    window.location.replace(url);
  };

  return (
    <>
      <Header>

        <Button variant='outlined' href={ExternalURLsHelper.getAjudaRNPURL()} target='_blank' rel="noreferrer">Mais informações</Button>
        {isHmg && <HmgLabelTopRight>HMG</HmgLabelTopRight>}
      </Header>
      <Container>
        <Wrapper>
          <div style={{
            textAlign: 'center',
            padding: '2rem 0',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '80.7vh',
            justifyContent: 'center'
          }}>
            <div>
              <h1>Mapeador de Atributos - CAFe</h1>
              <p style={{ fontSize: '1.25rem' }}>O Mapeador de Atributos da CAFe é um serviço de apoio para outros serviços 
                que fazem uso de atributos específicos da CAFe (como o ICPEdu Pessoal e o Assinador de Documentos). 
                O acesso  é restrito aos operadores cadastrados para cada instituição.</p>
              <p
                style={{ marginTop: '3rem', display: 'flex', flexDirection: 'column', maxWidth: '35%', gap: '0.5rem' }}>
                <Button size='large' onClick={handleLoginClick} style={{ fontWeight: 'bold', fontSize: '1.35rem' }}>
                  Acesse pela sua instituição*
                </Button>
                <span style={{ fontSize: '0.8rem', alignSelf: 'flex-end' }}>*Requer acesso como operador</span>
              </p>
            </div>
          </div>
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default Home;
